import {
  AttachmentResponse,
  CoverPhotoModel,
  ImagePreviewModel,
  PreviewFromServer,
} from 'types';
import genericNormalizer from './generic';

const sortPreviews = (previews: ImagePreviewModel[]) => {
  return previews
    ? previews.slice().sort((a, b) => a.width - b.width)
    : previews;
};

export const normalizeImagePreview = genericNormalizer<
  PreviewFromServer,
  ImagePreviewModel
>(({ from }) => ({
  scaled: from('scaled'),
  height: from('height'),
  url: from('url'),
  width: from('width'),
}));

export const normalizeImagePreviews = (previews: PreviewFromServer[]) => {
  return sortPreviews(
    previews.map((preview) => normalizeImagePreview(preview)),
  );
};

export const normalizeCoverPhoto = genericNormalizer<
  AttachmentResponse,
  CoverPhotoModel
>(({ from, has }) => ({
  url: from('url'),
  edgeColor: from('edgeColor'),
  previews: has('previews', normalizeImagePreviews),
}));



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/image-preview.ts